export enum HttpStatusCode {
  HTTP_200_OK = 200,
  HTTP_201_CREATED = 201,
  HTTP_202_ACCEPTED = 202,
  HTTP_204_NO_CONTENT = 204,
}
